module.exports = __webpack_public_path__ + "img/setcjf.402084e3.png";